import { initStore } from "./store";

const configureStore = () => {
  const actions = {
    SHOW_NOTIFICATION: (state, payload) => {
      const notifyContent = {
        status: payload.status,
        title: payload.title,
        message: payload.message,
      };
      return { 
        ...state,
        notification: notifyContent, 
        // i18n: state.i18next,
      };
    },
    CLEAR_NOTIFICATION: (state, payload) => {
      // const notifyContent = {
      //   status: null,
      //   title: null,
      //   message: null,
      // };
      return { 
        ...state,
        notification: null,
        // notification: notifyContent,
        // i18n: state.i18next,
       };
    },
    SET_USERSDATA: (state, payload) => {
      return {
        ...state,
        usersData: payload,
      }
    },
    SET_GROUP_USERSDATA: (state, payload) => {
      return {
        ...state,
        groupUsersData: payload,
      }
    },
    SET_GROUPMEMBER_IMAGEURLS: (state, payload) => {
      return {
        ...state,
        groupMemberImageUrls: payload,
      }
    },
    SET_USERDATA: (state, payload) => {
      return {
        ...state,
        userData: payload,
      }
    },
    SET_USER_ADELEMENTS: (state, payload) => {
      return {
        ...state,
        userAdElements: payload,
      }
    },
    SET_SELECTED_ADELEMENT: (state, payload) => {
      return {
        ...state,
        selectedAdElement: payload,
      }
    },
    SET_LISTFOR_SEARCHAD: (state, payload) => {
      return {
        ...state,
        listForSearchAd: payload,
      }
    },
    SET_LANGUAGE_NAME_LIST: (state, payload) => {
      return {
        ...state,
        languageNameList: payload,
      }
    },
    SET_USERNAMEDATA: (state, payload) => {
      return {
        ...state,
        userNameData: payload,
      }
    },
    SET_GLOADING: (state, payload) => {
      return {
        ...state,
        gLoading: payload,
      }
    },
    // SET_I18NEXT: (state, payload) => {
    //   return { 
    //     notification: state.notification,
    //     i18n: payload,
    //   }
    // }
  };

  initStore(actions, {
    notification: null,
    usersData: [],
    groupUsersData: [],
    groupMemberImageUrls: [],
    userData: null,
    userAdElements: [],
    selectedAdElement: null,
    listForSearchAd: [],
    languageNameList: [],
    userNameData: null,
    gLoading: false,
    // isUiLoading: false,

    // notification: {
    //   status: null,
    //   title: null,
    //   message: null,
    // },
    // i18n : undefined
  });
};

export default configureStore;
